import { render, staticRenderFns } from "./randomAvatar.vue?vue&type=template&id=2f5bd59a&scoped=true&"
import script from "./randomAvatar.vue?vue&type=script&lang=js&"
export * from "./randomAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5bd59a",
  null
  
)

export default component.exports